import'string.prototype.startswith';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import AcceptedToba from "../components/acceptedToba";
import { push,goBack } from 'connected-react-router'
// import download from "in-browser-download";
import {requestGetAcceptedToba} from "../actions/manageSolicitorAccount";
import {_getFileFromBase64} from "../helpers/functions";

class AcceptedTobaHOC extends Component {

    componentDidMount(){
        this.props.getAcceptedToba(this.props.manageSolicitorAccount.solicitorData.lastAcceptedTobaId)
    }

    // _getFileFromBase64 = (documentToDownload) => {
    //     download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    // };

    render() {
        if(this.props.user.loggedInUser.roles[0] === "Solicitor"){
            return (
                <AcceptedToba
                    fetchingAcceptedTobaFailMessage={this.props.manageSolicitorAccount.fetchingAcceptedTobaFailMessage}
                    fetchingAcceptedToba={this.props.manageSolicitorAccount.fetchingAcceptedToba}
                    _getFileFromBase64={_getFileFromBase64}
                    push={this.props.push}
                    goBack= {this.props.goBack}
            urerRole={this.props.user.loggedInUser.roles[0]}
                    Toba={this.props.manageSolicitorAccount.acceptedToba}/>
            )
        }else{
            return (
                null
            )
        }

    }
}

const mapStateToProps = (state) => {
    return {
        manageSolicitorAccount: state.manageSolicitorAccount,
        user: state.user,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        push: (url)=> {
            dispatch(push(url))
        },
        getAcceptedToba: (id) => {
            dispatch(requestGetAcceptedToba(id))
        },
        goBack: ()=> {
            dispatch(goBack())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AcceptedTobaHOC);
